export function scrollAllToTop(): void {
  // Scroll top-levels first
  try {
    window.scrollTo?.({ top: 0, behavior: 'smooth' } as ScrollToOptions);
  } catch {
    // older browsers fallback
    try {
      (document.documentElement as HTMLElement).scrollTop = 0;
      (document.body as HTMLElement).scrollTop = 0;
    } catch {}
  }

  const isVisible = (el: Element) => {
    const rect = (el as HTMLElement).getBoundingClientRect?.();
    if (!rect) return false;
    return rect.width > 0 && rect.height > 0;
  };

  const all = Array.from(document.querySelectorAll<HTMLElement>('*'));
  const scrollable = all.filter((el) => {
    if (!el || el === document.documentElement || el === document.body) return false;

    if (!isVisible(el)) return false;

    const style = window.getComputedStyle(el);
    const overflowY = style.overflowY;
    const canScrollY = overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay';
    const isScrollable = el.scrollHeight > el.clientHeight && canScrollY;

    return isScrollable;
  });

  const outermost: HTMLElement[] = [];
  scrollable.forEach((el) => {
    const hasScrollableAncestor = scrollable.some(
      (ancestor) => ancestor !== el && ancestor.contains(el),
    );
    if (!hasScrollableAncestor) outermost.push(el);
  });

  outermost.forEach((el) => {
    try {
      el.scrollTo?.({ top: 0, behavior: 'smooth' } as ScrollToOptions);
    } catch {
      el.scrollTop = 0;
    }
  });

  all.forEach((el) => {
    try {
      if (el.scrollHeight > el.clientHeight) (el as HTMLElement).scrollTop = 0;
    } catch {}
  });
}
